import React from 'react'

import clsx from 'clsx'

import classes from './Title.module.scss'

/** @type {import("./types").default} */
const Title = ({ children, className }) => <h2 className={clsx('Title', classes.title, className)}>{children}</h2>

export default Title
